<template>
  <element>
    <AppBar :title="title" />
    <v-container class="pt-0">
      <v-icon class="page-icon" color="#2e384d" size=60>mdi-star</v-icon>
      <p class="desc">{{ $t('assessPartCondition.description') }}</p>
      <section class="d-flex flex-column mt-3">
        <v-select
            :items="partConditions"
            :label="$t('assessPartCondition.selectionLabel')"
            :open-on-clear=true
            :outlined=true
            :rounded=true
            :clearable=true
            item-value="part_condition"
            @change="selectionChanged"
          >
          
                     
          </v-select>
      </section>
      <v-btn
        class="white--text"
        color="#033e8c"
        height="45px"
        block
        @click="complete"
        :disabled="disableCompleteButton"
      >
        {{ completeBtnTitle }}
      </v-btn>
    </v-container>
  </element>
</template>

<script>
import AppBar from "@/components/common/AppBar.vue"

export default {
  name: "AssessPartCondition",
  props: {},
  components: {
    AppBar
  },
  data() {
    return {
        selectedPartCondition:null,
        partConditions: ['A', 'B', 'C']
    }
  },
  created(){
    this.title = this.$store.getters.getCurrentTask.taskName
  },

  methods: {
      selectionChanged(part_condition)
      {
          console.log(`selected part condition: ${part_condition}`)
          this.selectedPartCondition=part_condition
      },
      complete() {
      const variables = {
        "variables": {
          "part_condition": {
            "value": this.selectedPartCondition,
            "type": "String"
          }
        }
      }
      
      const taskId = this.$store.getters.getCurrentTask?.id

      if (taskId) {
        this.$store.dispatch('completeTask', { taskId, variables })
        .then(response => {
          console.log("Task completed successfully!", taskId, response)
        })
        .catch(error => {
          console.log("Failed completing task!", taskId, error)
        })
      }
    },
    
  },

  computed: {
    disableCompleteButton: function () {
      if (this.selectedPartCondition!=null && this.selectedPartCondition!=undefined)
          return false
      else
          return true
    },
    completeBtnTitle()
    {
      return this.$store.getters.getCurrentTask.taskName
    }      

  },

  watch: {

  }
}
</script>

<style scoped>

</style>
